import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Footer.scss';
import Banner from '../../Images/Banner.png'
import AreaData from '../../Components/ServicesPage/AreaData'
import LocationData from '../../Components/LocationAll/LocationData'

export default function Footer({ WebSitePages, navigateTo }) {
    const Navigate = useNavigate()
    return (
        <div className="Footer">
            <div className="Footer2">
                <div className="Footer2Logo" onClick={() => navigateTo("")}>
                    <img src={Banner} alt="Chimney Sweep In Pomona, CA | Chimney Repair In Pomona, CA | Chimney Services In Pomona, CA | Chimney Inspection In Pomona, CA" />
                    <h1>Chimney Sweep<b> Pomona</b></h1>
                </div>
            </div>
            <div className="FooterTop">
                <div className="SiteMapDiv">
                    <h1>Pomona Chimney Sweep</h1>
                    <div className="SiteMapDivList">
                        <a href="/">Home Page</a>
                        <a href="/book">Schedule Online</a>
                        <a href="/contact">Contact Us</a>
                        <a href="/services">Our Services</a>
                        <a href="/blog">Blog</a>
                        <a href="/faq">Faqs</a>
                        <a href="/locations">locations</a>
                        <a href={`/reviews/${LocationData.find(a => a.City == ("Pomona").replace("%20", '')).City.replace(" ", '').toLowerCase()}`}>Customer Reviews</a>
                        <a href="/sitemap">Site Map</a>
                    </div>
                </div>
                <div className="SiteMapDiv">
                    <h1>Contact Us</h1>
                    <div className="SiteMapDivList">
                        <a target='_blank' href="">
                            Pomona, California
                        </a>
                        <a target='_blank' href="tel:951-330-3128">
                            951-330-3128
                        </a>
                        <a target='_blank' href="mailto:info@Pomonahimneysweep.org">
                            info@Pomonahimneysweep.org
                        </a>
                    </div>
                </div>
                <div className="SiteMapDiv">
                    <h1>Services</h1>
                    <div className="SiteMapDivList">
                        {AreaData.map((A, index) =>
                            <a href={A.Path} className="Header1BoxMenuBox">
                                {A.Title}
                            </a>
                        )}
                    </div>
                </div>

            </div>
            <div className="Footer3">
                <h1>Copyright 2024 Chinmey Sweep Pomona. All rights reserved. All available services, hours of operations, pricing structure, and guarantees may vary by location.</h1>
            </div>
        </div>
    )
}
